import type { App, UsedBlinkActions } from '../types.js';

export type Data = {
  actions: UsedBlinkActions;
  apps: App[];
};

const initialState = {
  error: null,
  loaded: false,
  data: {
    actions: {},
    apps: [],
  } as Data,
};

export default initialState;
